import { capitalize, isEmpty } from 'lodash'
import { useNavigate } from 'react-router-dom'

import { TAppTypesApiSubstitutes } from 'types/apps'
import { TPermission } from 'types/permissions'
import { convertApiAppNameToDisplay } from 'utils/rolesPermissions/convertAppNames'

type TProps = {
  name: string
  permissions: TPermission[]
  uuid: string
}

const RolesPermissionsItem = ({ name, permissions, uuid }: TProps) => {
  const navigate = useNavigate()

  const permissionsWithoutSuperAdmin = permissions?.filter(
    (permission) => permission?.subject?.toLowerCase() !== 'superadmin'
  )

  const displayPermissions = (permissions: TPermission[]): string =>
    permissions
      ?.map((permission) =>
        // If permission.subject include TAppTypesApiSubstitutes we have to convert it to displayable name
        // if not just capitalize name
        !isEmpty(convertApiAppNameToDisplay(permission.subject as TAppTypesApiSubstitutes))
          ? convertApiAppNameToDisplay(permission.subject as TAppTypesApiSubstitutes)
          : capitalize(permission.subject)
      )
      .join(', ')

  const onClickItem = () => navigate(`/roles-permissions/edit/${uuid}`)

  return (
    <div className="item" onClick={onClickItem} role="button">
      <div className="row">
        <div className="item-info-wrapper">{name}</div>
        <div className="item-info-wrapper">{displayPermissions(permissionsWithoutSuperAdmin)}</div>
      </div>
    </div>
  )
}

export default RolesPermissionsItem
